import Vue from 'vue'
import { Image } from 'element-ui'

Vue.use(Image)
